import React from 'react';

export default class SearchStatus extends React.Component {
  render() {
    const pluralizedResult = this.props.totalResults === 1 ? 'result' : 'results';
    const cleanedSeconds = parseFloat(this.props.time.replace('s', ''), 10);
    const pluralizedSecond = cleanedSeconds === 1 ? 'second' : 'seconds';

    return (
      <div className="search-status">
        About {this.props.totalResults} {pluralizedResult} ({cleanedSeconds} {pluralizedSecond})
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/SearchStatus.js